import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";

export default function ResponsiveDialog({
	open,
	handleClose,
	title,
	subtitle,
	handleRequestApprove,
	approveLoading,
}) {
	return (
		<div>
			<Dialog
				open={open}
				onClose={handleClose}
				aria-labelledby="responsive-dialog-title"
				sx={{
					borderRadius: "50px",
					"& .MuiDialog-paper": {
						borderRadius: "50px",
					},
				}}
			>
				<DialogTitle id="responsive-dialog-title">
					<Box
						sx={{
							display: "flex",
							flexDirection: "column",
							alignItems: "center",
						}}
					>
						<Typography
							variant="h6"
							component="div"
							sx={{ color: "primary.main", fontWeight: 700 }}
						>
							{title}
						</Typography>
						<Typography
							variant="h6"
							gutterBottom
							component="div"
							sx={{ color: "primary.main", fontWeight: 700 }}
						>
							{subtitle}
						</Typography>
					</Box>
				</DialogTitle>
				<DialogContent
					sx={{
						paddingLeft: "2rem",
						paddingRight: "2rem",
						textAlign: "center",
					}}
				>
					<Box
						sx={{
							display: "flex",
							flexDirection: "column",
							alignItems: "center",
							marginBottom: "2rem",
						}}
					>
						<Typography
							variant="body2"
							sx={{
								fontWeight: 700,
								color: "primary.main",
							}}
							gutterBottom
							component="div"
						>
							Do you want to approve this request?
						</Typography>
						<Box
							sx={{
								display: "flex",
								justifyContent: "center",
								marginTop: "1rem",
							}}
						>
							<Stack direction="row" spacing={2} sx={{ alignSelf: "center" }}>
								<Button
									sx={{
										backgroundColor: "#10AF6A",
										paddingLeft: "2rem",
										paddingRight: "2rem",
									}}
									variant="contained"
									onClick={() => handleRequestApprove()}
									disabled={approveLoading}
								>
									{approveLoading ? (
										<CircularProgress size="1.5rem" />
									) : (
										"Confirm Approval"
									)}
								</Button>
								<Button
									sx={{
										backgroundColor: "primary.main",
										paddingLeft: "3rem",
										paddingRight: "3rem",
									}}
									variant="contained"
									onClick={() => {
										handleClose();
									}}
								>
									cancel
								</Button>
							</Stack>
						</Box>
					</Box>
				</DialogContent>
			</Dialog>
		</div>
	);
}
